import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FacadeService } from 'src/app/core/services/facade.service';
import { User } from 'src/app/shared/models/security/user';
import { CookieService } from 'ngx-cookie-service';
import { MessageNotification } from 'src/app/shared/models/message-notification';
import { forkJoin, Observable, of } from 'rxjs';
import { Conversation } from 'src/app/shared/models/messaging/conversation';

@Component({
	selector: 'app-new-conversation',
	templateUrl: './new-conversation.component.html',
	styleUrls: ['./new-conversation.component.scss']
})
export class NewConversationComponent implements OnInit {
	user: User;
	listUser: User[];
	filteredUsers: User[];
	searchedName = '';
	@Input() usersForNewConversation: User[] = [];
	@Input() secondPersonId: User;
	@Output() receiver = new EventEmitter<User>();
	@Output() openConversation = new EventEmitter();
	@Output() newConvClose = new EventEmitter();

	@Input() notifications: MessageNotification[] = [];

	constructor(private facade: FacadeService) {}

	ngOnInit(): void {
		this.user = this.facade.dataStorageService.getUser();

		this.facade.userService
			.getAllExistingConversations()
			.subscribe((conversationList: Conversation[]) => {
				this.filteredUsers = this.usersForNewConversation.filter((user) => {
					return !conversationList.find((userWithConv) => {
						return userWithConv.user.id === user.id;
					});
				});
			});
	}

	//transfert de l'employee du fils vers le parent
	emitReceiver(userReceiver: User) {
		this.receiver.emit(userReceiver);
		this.openConv();
	}

	getNotificationNumberByIdSender(idSender): number {
		const notif = this.notifications.find((notification) => {
			return notification.idSender === idSender;
		});

		return notif ? notif.messagesNumber : 0;
	}

	openConv() {
		this.openConversation.emit(true);
	}

	backToExistingConv() {
		this.newConvClose.emit(false);
	}
}
